import { render, staticRenderFns } from "./artdire.vue?vue&type=template&id=d4611ea8&scoped=true&"
import script from "./artdire.vue?vue&type=script&lang=js&"
export * from "./artdire.vue?vue&type=script&lang=js&"
import style0 from "./artdire.vue?vue&type=style&index=0&id=d4611ea8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4611ea8",
  null
  
)

export default component.exports